/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tag_RentalInputs */

const cs_tag_rental = /** @type {(inputs: Tag_RentalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pronájem`)
};

const en_tag_rental = /** @type {(inputs: Tag_RentalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rental`)
};

/**
* | output |
* | --- |
* | "Rental" |
*
* @param {Tag_RentalInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const tag_rental = /** @type {((inputs?: Tag_RentalInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tag_RentalInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_tag_rental(inputs)
	return cs_tag_rental(inputs)
});